"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["size", "alt", "background", "className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = ".Icon__utility {\n  width: 1.5rem;\n  height: 1.5rem;\n  min-width: 1.5rem;\n}\n.Icon__badge {\n  width: 4rem;\n  height: 4rem;\n  min-width: 4rem;\n}\n.Icon__spot {\n  width: 8rem;\n  height: 8rem;\n  min-width: 8rem;\n}\n.Icon__background {\n  aspect-ratio: 1;\n  width: 8rem;\n  height: 8rem;\n  border-radius: 50%;\n  background-color: #cee6ff;\n}\n.Icon__background :first-of-type {\n  position: relative;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.Icon__background--badge {\n  background-color: #E6F2FF;\n  width: 4rem;\n  height: 4rem;\n}";
  var fileName = "Icon_Icon";
  var element = document.querySelector("style[data-sass-component='Icon_Icon']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var Icon = function Icon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'badge' : _ref$size,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? 'Icon' : _ref$alt,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? false : _ref$background,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var image = /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread({
    alt: alt,
    className: "Icon ".concat(className, "  Icon__").concat(size)
  }, rest));
  if (background && size !== 'utility') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "Icon__background ".concat(size === 'badge' ? 'Icon__background--badge' : ''),
      children: image
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: image
  });
};
var _default = Icon;
exports["default"] = _default;